import { render, staticRenderFns } from "./ModalPendenciasCadastro.vue?vue&type=template&id=1b9d5e9e&"
import script from "./ModalPendenciasCadastro.vue?vue&type=script&lang=js&"
export * from "./ModalPendenciasCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports